import React from "react";
import { DateTime } from "luxon";

const WeekDisplay: React.FC = () => {
  const now = DateTime.now();
  const weekNumber = now.weekNumber;

  // Get start of week (Monday) and end of week (Sunday)
  const startOfWeek = now.startOf("week");
  const endOfWeek = now.endOf("week");

  const dateRange = `${startOfWeek.toFormat("MMM d")} - ${endOfWeek.toFormat("MMM d, yyyy")}`;

  return (
    <div className="flex flex-col items-end text-right">
      <div className="text-3xl font-bold text-gray-900 dark:text-white">
        Week {weekNumber}
      </div>
      <div className="text-sm text-gray-600 dark:text-gray-400">
        {dateRange}
      </div>
    </div>
  );
};

export default WeekDisplay;
